export default "__VITE_ASSET__7245ed74__"